export default [
  { value: "NONE", key: "clientCoverages.taxTypes.none" },
  { value: "INSURANCE", key: "clientCoverages.taxTypes.insurance" },
  { value: "SALES", key: "clientCoverages.taxTypes.sales" },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/enums/clientCoverageTaxTypes.js